import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from "@heroui/react";
import { DNA, ThreeDots } from "react-loader-spinner";

export const ErrorFallback = ({ error, resetErrorBoundary }: any) => {
  const { onOpenChange } = useDisclosure();

  return (
    <>
      <Modal
        defaultOpen
        isDismissable={true}
        size={"lg"}
        onOpenChange={onOpenChange}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1 bg-slate-800 text-gray-200">
                Error Occurred
              </ModalHeader>
              <ModalBody className="bg-rose-600">
                <div role="alert">
                  <p>Something went wrong:</p>
                  <pre className={"text-rose-500"}>{error.message}</pre>
                </div>
              </ModalBody>
              <ModalFooter className="bg-slate-800">
                <Button
                  color={"primary"}
                  onClick={resetErrorBoundary}
                  onPress={onClose}
                >
                  Try again
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export const SuspenseFallback = () => (
  <div className="h-screen w-full relative mx-auto flex flex-col items-center justify-center z-10">
    <DNA ariaLabel="bars-loading" height="80" visible={true} width="80" />
    <span>Loading...</span>
  </div>
);

export const LoadingFallback = () => (
  <div className="w-full h-full flex flex-col items-center justify-center">
    <ThreeDots ariaLabel="loading" height="80" visible={true} width="80" />
  </div>
);

type Props = {
  children: React.ReactNode;
};

export const Loaders = ({ children }: Props) => (
  <div className="w-full h-full flex flex-col items-center justify-center">
    {children}
  </div>
);
